// External deps

import PropTypes from 'prop-types';

// Internal deps
import LineMonthlyRowContainer from '../LineMonthlyRowContainer/LineMonthlyRowContainer';
import { PositionLinePermissions } from '../../../../MonthlyServiceRequest/RequestDetailTypes';

const LinesMonthHeader = (props) => {
  const {
    positions,
    changeInLine,
    setChangeInLine,
    setSelectedLine,
    selectedLine,
    idWorkLineMonthly,
    positionLinesPermissions,
    disabledEditStateCancelOrFinish
  } = props;

  return (
    <ul className="list_container">
      {positions.map((position, index) => (
        <LineMonthlyRowContainer
          changeInLine={changeInLine}
          disabledEditStateCancelOrFinish={disabledEditStateCancelOrFinish}
          idWorkLineMonthly={idWorkLineMonthly}
          index={index}
          key={`${index.toString()}-${position.numeroPosicion}`}
          position={{
            ...position,
            index
          }}
          positionLinesPermissions={positionLinesPermissions}
          selectedLine={selectedLine}
          setChangeInLine={setChangeInLine}
          setSelectedLine={setSelectedLine}
        />
      ))}
    </ul>
  );
};

LinesMonthHeader.propTypes = {
  positions: PropTypes.arrayOf(
    PropTypes.shape({
      descripcionLineaSap: PropTypes.string,
      descripcionLineaYClic: PropTypes.string,
      descripcionPosicionSap: PropTypes.string,
      descripcionPosicionYClic: PropTypes.string,
      fechaCreacion: PropTypes.string,
      idParteTrabajoLinea: PropTypes.number,
      idPartetrabajo: PropTypes.number,
      numeroLinea: PropTypes.number,
      numeroPosicion: PropTypes.number,
      unidadMedida: PropTypes.string
    })
  ).isRequired,
  changeInLine: PropTypes.bool.isRequired,
  setChangeInLine: PropTypes.func.isRequired,
  setSelectedLine: PropTypes.func.isRequired,
  selectedLine: PropTypes.shape({
    index: PropTypes.number
  }),
  idWorkLineMonthly: PropTypes.number,
  positionLinesPermissions: PositionLinePermissions.isRequired,
  disabledEditStateCancelOrFinish: PropTypes.bool.isRequired
};

LinesMonthHeader.defaultProps = {
  selectedLine: 0,
  idWorkLineMonthly: 0
};

export default LinesMonthHeader;
